// extracted by mini-css-extract-plugin
export default {"modeloFicha":"ModeloFicha_modeloFicha__opTzP","modeloFichaButton":"ModeloFicha_modeloFichaButton__dxLOZ"};